import React from 'react';
import { Button, Result, Typography } from 'antd';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/client';
import { useAuth } from '../../auth/AuthContext';
import './NoRoleAccessPage.css';

const { Paragraph, Text } = Typography;

/**
 * Shown when the user is authenticated but has no assigned admin role (claims + Firestore).
 */
function NoRoleAccessPage() {
    const { user } = useAuth();

    return (
        <div className="no-role-access">
            <Result
                status="403"
                title="No admin access"
                subTitle="Your account is signed in but has no role assigned for this application."
                extra={
                    <div className="no-role-access__extra">
                        <Paragraph>
                            Ask a Firebase administrator to create a document for your user ID in Firestore
                            (see internal docs: <Text code>FIREBASE_ROLES_SETUP.md</Text>) or assign a custom
                            claim <Text code>role</Text>.
                        </Paragraph>
                        {user?.uid ? (
                            <Paragraph copyable={{ text: user.uid }}>
                                <Text strong>Your UID:</Text> <Text code>{user.uid}</Text>
                            </Paragraph>
                        ) : null}
                        <Button type="primary" onClick={() => signOut(auth)}>
                            Sign out
                        </Button>
                    </div>
                }
            />
        </div>
    );
}

export default NoRoleAccessPage;
